import { AgentState, useAgentStore } from "@/common/stores/persistingStores/agentPermissions";
import { useWebchatMessaging } from "@/hooks/webchat";
import { WebchatMessagesKey } from "@/repository/queryFns";
import { useMemo } from "react";
import { MessagingInteractionContentProps } from "./types";
import { InteractionType } from "@/common/types";
import { WebchatTextEditor } from "./WebchatTextEditor";
import {
	useCurrentInteractionStore,
	CurrentInteractionState,
} from "@/common/stores/nonpersistingStores/currentInteraction";
import { MessagingChatLayout, useImageOverlay } from "./MessagingChatLayout";
import {
	useMessagingNotifications,
	useAddMessagesInChat,
	useHandleError,
} from "./useMessagingNotifications";

export const WebchatChatInteractionContent = (
	props: MessagingInteractionContentProps
) => {
	const { interactionId, isHistory = false } = props;

	const agentName = useAgentStore((state: AgentState) => state.fullName);

	const currentInteraction = useCurrentInteractionStore(
		(state: CurrentInteractionState) => state.active
	);

	const chatQueryKey = useMemo(
		() => [WebchatMessagesKey, "", {}, undefined, interactionId],
		[interactionId]
	);

	useMessagingNotifications(chatQueryKey);

	const addMessagesInChat = useAddMessagesInChat(chatQueryKey);
	const handleError = useHandleError(
		interactionId,
		InteractionType[InteractionType.Webchat].toString(),
		chatQueryKey
	);

	const { overlayImageItem, dismissOverlay, imageWrapper } = useImageOverlay();

	const messagingMethods = useWebchatMessaging(
		agentName,
		interactionId,
		isHistory,
		addMessagesInChat,
		handleError,
		imageWrapper
	);

	return (
		<MessagingChatLayout
			messagingMethods={messagingMethods}
			props={props}
			overlayImageItem={overlayImageItem}
			onOverlayDismiss={dismissOverlay}
			sendBoxContent={
				!messagingMethods.isChatClosed ? (
					<WebchatTextEditor
						sendMessages={messagingMethods.sendMessages}
						allowAttachments={true}
						interactionId={interactionId}
						isDisabled={currentInteraction?.isOnHold}
					/>
				) : undefined
			}
		/>
	);
};
